export default {
  presenter: 'novy_stec',
  title: 'Jak zabezpečit ssh server',
  subtitle: 'začátečníci',
  text: `
SSH server je na většině linuxových distribucí již předinstalovaný a funkční. Ale je v této
defaultní konfiguraci bezpečný? Na workshopu si ukážeme, co by nemělo chybět v konfiguraci
OpenSSH démona, vyzkoušíme si základy asymetrické kryptografie a nastavíme základní firewall
pomocí nástroje iptables.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/novy-stec-zabezpeceni.js